import '../node_modules/ismobilejs/esm/index.mjs';
import isMobile$1 from '../node_modules/ismobilejs/esm/isMobile.mjs';

const isMobile = isMobile$1(globalThis.navigator);

export { isMobile };
//# sourceMappingURL=isMobile.mjs.map
